import { render, staticRenderFns } from "./PrevisaoGatilho.vue?vue&type=template&id=6c32b057&scoped=true"
import script from "./PrevisaoGatilho.vue?vue&type=script&lang=js"
export * from "./PrevisaoGatilho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c32b057",
  null
  
)

export default component.exports